import { Component, inject, Input, SimpleChanges, OnDestroy, OnInit, OnChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OrderApiService } from '@mavles/orders';
import { IAddress, IContact } from '@mavles/contacts';

@Component({
    selector: 'app-address-selector',
    templateUrl: './address-selector.component.html',
    styleUrl: './address-selector.component.scss',
    standalone: false
})
export class AddressSelectorComponent implements OnDestroy, OnInit, OnChanges {
  @Input() contact_id!: AbstractControl<any, any> | null;
  @Input() address_id!: AbstractControl<any, any> | null;
  @Input() show_selected = false;
  contact:IContact|undefined; 
  selectedAddress!:IAddress;

  private orderService    = inject(OrderApiService);
  private $subscrption:Subscription|undefined;

 

  ngOnDestroy(): void {
    this.$subscrption?.unsubscribe();
  }

  ngOnInit(): void {
    this.initFrom();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.initFrom();
  }

  private initFrom(){
    this.loadContact();
    
    // Unsubscribe previous to avoid leaks if inputs change
    if(this.$subscrption){
       this.$subscrption.unsubscribe();
    }
    
    this.$subscrption = new Subscription();

    if (this.contact_id) {
        this.$subscrption.add(this.contact_id.valueChanges.subscribe(() => {
            this.loadContact();
        }));
    }

    if (this.address_id) {
        this.$subscrption.add(this.address_id.valueChanges.subscribe(() => {
            this.setAddresses();
        }));
    }
  }

  private loadContact(){
    this.contact = this.orderService.getContactsForCurrentPage()?.find(c => c.contact_id === this.contact_id?.value);
    this.setAddresses();
  }

  setAddresses(): void {
    const selectedAddress = this.contact?.address?.find(a => a.address_id === this.address_id?.value);
    if (!selectedAddress) {
       // If selected address not found in the new contact (or no selection), select default if available?
       // Keeping existing logic: if no selection found, try set first.
       if (this.contact?.address?.length) {
          // Only auto-select if nothing is selected or current selection is invalid?
          // The previous logic was: if (!selectedAddress) this.address_id.setValue(...)
          // But check if we want to overwrite null... assuming yes for now based on previous code.
          // However, be careful not to loop if setValue triggers valueChanges.
          // The current value is address_id.value.
          
          // Let's just update selectedAddress if found. If not found, and we have addresses, maybe pick first.
          
           if(this.address_id?.value){
              // Value exists but not found in contact -> mismatch
           } else {
               // No value, pick first
               // this.address_id?.setValue(this.contact.address[0].address_id);
           }
       }
        this.selectedAddress = undefined as any; 
    } else {
        this.selectedAddress = selectedAddress;
    }
    
    // Original logic restoration with fix:
    const found = this.contact?.address?.find(a => a.address_id === this.address_id?.value);
    if(found){
        this.selectedAddress = found;
    } else {
        // If not found, check if we should default?
        if(this.contact?.address && this.contact.address.length > 0 && !this.address_id?.value){
             // Select first if nothing selected
             this.address_id?.setValue(this.contact.address[0].address_id); 
             // Triggers valueChange -> recurses to setAddresses -> found will be true.
        } else {
             this.selectedAddress = undefined as any;
        }
    }
  }
}


